<div class="notifications" >
  <div *ngFor="let displayed of displayedAlerts"
       class="{{ cssClass(displayed.alert) }} alert-dismissable"
       [@someCoolAnimation]="displayed.state"
       (@someCoolAnimation.done)="onAnimationDone(displayed)"
       (mouseenter)="hold(displayed)"
       (mouseleave)="release(displayed)">
      {{displayed.alert.message}}
      <a class="close" (click)="dismiss(displayed)">&times;</a>
  </div>
</div>
